const reportMetricsMessages = {
  pageTitles: {
    titleAndSubtitle: {
      title: '50-50 Report Plan',
      subTitle: 'Showing employer claims data from ',
    },
  },
  specificDeductible: {
    title: 'Specific Deductibles',
    subTitle: 'To see more about the specific deductible click on a category',
    noData: 'No members crossing 50% of specifiic deductibles !',
    memberDetails: 'Member Details by ',
    memberDetailsSubtitle1: 'List of members crossing ',
    memberDetailsSubtitle2: ' of Specific Deductible',
    dropDownValues: [''],
  },

  buttonText: {
    download: 'Download',
    queryData: 'Query Data',
    submit: 'Submit',
  },
  cardText: {
    members: 'Cohort Members',
    totalCost: 'Cohort Cost',
    medical: 'Medical',
    rx: 'Rx',
    pmpm: 'Cohort PMPM',
    pepm: 'Cohort PEPM',
  },
  stopLossReport: '50-50 Stop Loss Report',
  PLAN: ' plan',
};

export default reportMetricsMessages;
